import type { AccountAccess } from "@/features/auth/access";
export function canAdminister(account: AccountAccess | undefined, actorId?: string) {
  return Boolean(account && (!actorId || account.id === actorId) && account.role === "ADMIN" && !account.isBanned && !account.isLocked && !account.isDeleting);
}

export class AdminAccessDenied extends Error {
  constructor() { super("Administrator access is required."); this.name = "AdminAccessDenied"; }
}

export function canWriteAdmin(account: AccountAccess | undefined, actorId?: string) { return canAdminister(account, actorId) && !account?.isPendingDelete; }
